import { render, staticRenderFns } from "./Step2.vue?vue&type=template&id=a96520b8&scoped=true&"
import script from "./Step2.vue?vue&type=script&lang=js&"
export * from "./Step2.vue?vue&type=script&lang=js&"
import style0 from "./Step2.vue?vue&type=style&index=0&id=a96520b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a96520b8",
  null
  
)

component.options.__file = "Step2.vue"
export default component.exports